var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCopyWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49986 7.50002H8.99986V9.00002C8.99986 9.30002 9.19986 9.50002 9.49986 9.50002H10.4999C10.7999 9.50002 10.9999 9.30002 10.9999 9.00002V7.50002H12.4999C12.7999 7.50002 12.9999 7.30002 12.9999 7.00002V6.00002C12.9999 5.70002 12.7999 5.50002 12.4999 5.50002H10.9999V4.00002C10.9999 3.70002 10.7999 3.50002 10.4999 3.50002H9.49986C9.19986 3.50002 8.99986 3.70002 8.99986 4.00002V5.50002H7.49986C7.19986 5.50002 6.99986 5.70002 6.99986 6.00002V7.00002C6.99986 7.30002 7.19986 7.50002 7.49986 7.50002ZM15 0.5H5C4.4 0.5 4 0.9 4 1.5V4.5H1C0.4 4.5 0 4.9 0 5.5V15.5C0 16.1 0.4 16.5 1 16.5H11C11.6 16.5 12 16.1 12 15.5V12.5H15C15.6 12.5 16 12.1 16 11.5V1.5C16 0.9 15.6 0.5 15 0.5ZM10.0002 14.5H2.00021V6.50005H4.00021V11.5C4.00021 12.1 4.40021 12.5 5.00021 12.5H10.0002V14.5ZM14 10.5001H6.00005V2.50006H14V10.5001Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCopyWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-Copy-White.26ebbfa627425ef684d9732d1177bfa7.svg";